module.exports = __webpack_public_path__ + "img/elixir_introduction.8ff8ba30.jpg";